// extracted by mini-css-extract-plugin
export default {"anim":"Amount_anim__CmTLB","backgroundColor":"Amount_backgroundColor__rqj-x"};